const quiz = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "quiz",
    items: [
      { id: "q1", question: "星期一后面是什么？", answers: ["星期二"], image: null },
      { id: "q2", question: "星期二后面是什么？", answers: ["星期三"], image: null },
      { id: "q3", question: "星期三后面是什么？", answers: ["星期四"], image: null },
      { id: "q4", question: "星期四后面是什么？", answers: ["星期五"], image: null },
      { id: "q5", question: "星期五后面是什么？", answers: ["星期六"], image: null },
      { id: "q6", question: "星期六后面是什么？", answers: ["星期日"], image: null },
      { id: "q7", question: "星期日后面是什么？", answers: ["星期一"], image: null },
      { id: "q8", question: "一周的第一天是什么？", answers: ["星期一"], image: null },
      { id: "q9", question: "一周的最后一天是什么？", answers: ["星期日"], image: null },
      { id: "q10", question: "一周有多少天？", answers: ["7", "七"], image: null },
    ],
  },
  botId: "nualang.quiz.0.0.1",
  botName: "quiz",
  description: "quiz_desc",
  difficulty: "ALL",
  learnLang: "chinese",
  name: "小雨",
  botAvatar:
    "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwMi5wbmcifQ==",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-question-circle?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# 欢迎来到测验
由小雨主持。

你知道一周的日子吗？

对小雨说"你好"开始。`,
  voice: "Zhiyu",
  versionQuestion: "你想在这个模板中有多少个问题？",
};

export default quiz;
